import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify'; // Import toast for notifications
import 'react-toastify/dist/ReactToastify.css'; // Import styles for ToastContainer
import InstanceLeftSidebar from "../InstanceLeftSidebar";
import PageHeaderWithBreadcrumbs from "../../../components/PageHeaderWithBreadcrumbs";
import './style.css'; // Import custom CSS

function InstanceSyncProducts() {
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // State to manage error messages
  const instanceUniqueId = 'elite-promo-marketing'; // Example instanceUniqueId

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const [productResponse, syncLogResponse] = await Promise.all([
          axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/products/fetch-products`, {
            params: { instanceUniqueId }
          }),
          axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/products/sync-log`, {
            params: { instanceUniqueId }
          })
        ]);
        
        setProducts(productResponse.data);

        // Extract synced products from the log and set them as selected
        if (syncLogResponse.data) {
          const syncedProductIds = syncLogResponse.data.products || [];
          setSelectedProducts(syncedProductIds);
        }

        setLoading(false);
      } catch (error) {
        console.error('Error fetching products:', error);
        setError('Failed to fetch products. Please try again later.');
        setLoading(false);
      }
    };

    fetchProducts();
  }, [instanceUniqueId]);

  const handleSelectProduct = (productId) => {
    setSelectedProducts(prevSelected =>
      prevSelected.includes(productId) ? prevSelected.filter(id => id !== productId) : [...prevSelected, productId]
    );
  };

  const handleSyncProducts = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_NODEJS_SERVER_URL}/products/sync-products`, {
        productIds: selectedProducts,
        instanceUniqueId
      });
      toast.success('Products synced successfully'); // Use toast for success notification
    } catch (error) {
      console.error('Error syncing products:', error);
      toast.error('Failed to sync products. Please try again later.'); // Use toast for error notification
    }
  };

  const placeholderImage = "https://via.placeholder.com/150";

  return (
    <div className="instance-dashboard">
      <InstanceLeftSidebar/>
      <ToastContainer/>
      <div className="rightSide place-items-top">
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="options-container fade-in-effect-usability">
              <div className="options-inner-container">
                <PageHeaderWithBreadcrumbs 
                  title="Products" 
                  breadcrumb="Product Manager"
                  includeButton={false}
                />
                <div className="sync-products-container">
                  <h1>Sync Products to WordPress</h1>
                  {error && <p className="error-message">{error}</p>} {/* Display error message */}
                  <div className="product-grid">
                    {products.map(product => (
                      <div key={product.id} className="product-item">
                        <img 
                          src={product.imageUrl ? `https://example.com/${product.imageUrl}` : placeholderImage} 
                          alt={product.name} 
                        />
                        <h2>{product.name}</h2>
                        <p>{product.markupPrice ? `$${product.markupPrice}` : 'No Price Available'}</p>
                        <input
                          type="checkbox"
                          checked={selectedProducts.includes(product.id)}
                          onChange={() => handleSelectProduct(product.id)}
                        />
                      </div>
                    ))}
                  </div>
                  <button className="sync-button" onClick={handleSyncProducts}>
                    Sync Selected Products ({selectedProducts.length} selected)
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default InstanceSyncProducts;
